import { InjectionToken } from '@angular/core';

// Re-declaration of types from web-api-client for library consumers
// Structurally compatible with the generated NSwag client types

export interface PriceItemDto {
  date?: Date;
  price?: number;
}

export enum EnergyType {
  Electric = 0,
  Gas = 1,
  Imbalance = 2,
}

export enum ViewType {
  Day = 0,
  Week = 1,
  Month = 2,
  Year = 3,
  DayHour = 4,
}

export enum VolumeEnum {
  KWh = 0,
  MWh = 1,
}

export enum UnitTypeEnum {
  KWh = 1,
  Euro = 2,
}

/** Injection token for the backend API base URL (e.g. 'https://api.enwyse.be') */
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
